import * as React from 'react';
import { useDispatch } from 'react-redux';
import { toggleStickyScrollBtn } from '../slices';

type TContainerRef = React.RefObject<HTMLElement>;

/** хук проверяет находится ли элемент выше текущего вьюпорта и переключает видимость кнопки */
export function useToggleStickyScrollBtn(ref: TContainerRef) {
  const dispatch = useDispatch();

  const checkIsElementOutOfViewport = React.useCallback(() => {
    const stickyContainer = ref.current?.getBoundingClientRect();

    if (stickyContainer && stickyContainer.bottom < 0) {
      dispatch(toggleStickyScrollBtn(true));
    } else {
      dispatch(toggleStickyScrollBtn(false));
    }
  }, [ref, dispatch]);

  React.useEffect(() => {
    window.addEventListener('scroll', checkIsElementOutOfViewport);

    return () => window.removeEventListener('scroll', checkIsElementOutOfViewport);
  }, [checkIsElementOutOfViewport]);
}
